export default __webpack_public_path__ + "static/media/rodaModalPicture.0f438d3a.png";